import { isEmptyString, isInt, isNumeric } from 'utils/helper';

export const isNumericInput = (value) => (isEmptyString(value) || isNumeric(value));

export const isIntInput = (value) => (isEmptyString(value) || isInt(value));

export const isCommaSeparatedList = (value) => (/^((\d)+,?)*$/.test(value));

export const isLegitPhoneChar = (value) => (/^(\d|\(|\)|\+|\-)*$/.test(value));